import { AppState } from 'types/app';
import { HolmesState } from 'types/holmes';

export const selectHolmes = (state: AppState) => state.holmes || ({} as HolmesState);

export const selectDirectedId = (state: AppState) => selectHolmes(state)?.directedId;
